import { MessageCircle } from "lucide-react";

interface WhatsAppCTAProps {
  phone?: string;
  message?: string;
  children?: React.ReactNode;
}

export default function WhatsAppCTA({
  phone = "555181046948",
  message,
  children,
}: WhatsAppCTAProps) {
  const whatsappLink = `https://wa.me/${phone}${
    message ? `?text=${encodeURIComponent(message)}` : ""
  }`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="
        inline-flex items-center justify-center gap-2
				mx-auto
        px-4 py-2 md:px-8 md:py-4
        font-sans font-semibold
        text-white text-base
        bg-gradient-to-r from-[#5BE5FF] via-[#307AFF] to-[#101820]
        md:rounded-xl rounded-md
        shadow-lg shadow-[#5BE5FF]/30
				md:hover:scale-103 md:hover:shadow-[#307AFF]/50
        transition-transform duration-200
        backdrop-blur-md
      "
    >
      <MessageCircle className="w-5 h-5" />
      {children || "Fale conosco!"}
    </a>
  );
}
